module.exports = __webpack_public_path__ + "static/media/疫情通告.1be957df.svg";